
















import { Component, Vue, Prop} from 'vue-property-decorator';
import { api } from '../api';

@Component
export default class DocPreviewDialog extends Vue {
  @Prop(String) public baseUrl!: string;
  public api = api;
  public dialog = false;
  public currentPage = 0;
  public pageCount = 0;
  public pdfUrl = '';

  public async open(fileurl: string) {
    const url = await this.api.getFileURL(this.$store, fileurl, false);
    this.pdfUrl = url;
    this.dialog = true;
  }

  public async openurl(url: string) {
    this.pdfUrl = url;
    this.dialog = true;
  }
}
